import httpClient from '../../shared/services/httpClient';

export const SubscriptionCreate = async (data: AsaasSubscription) => {
  const response = await httpClient.post('/subscription/create', data);
  return response.data;
};
